const RATE_LIST = [62, 65, 44, 73, 39.43, 38, 54, 40.8, 60, 70, 95, 48, 100];

const defaultSettingObject = {
  control: (provided, state) => ({
    ...provided,
    paddingLeft: "16px",
    paddingRight: "16px",
    height: "44px",
    borderRadius: "8px",
    border: "0.5px solid #ccc",
    boxShadow: "none",
  }),
  container: (provided, state) => ({
    ...provided,
    width: "100%",
    height: "44px",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    padding: 0,
  }),
  menu: (provided, state) => ({
    ...provided,
    paddingTop: "12px",
    paddingBottom: "12px",
    borderRadius: "6px",
    border: "solid 0.5px #eaeaea",
    boxShadow: "0 0 12px 0 rgba(0, 0, 0, 0.12)",
  }),
  menuList: (provided, state) => ({
    ...provided,
    padding: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    marginRight: "12px",
    marginLeft: "12px",
    width: "auto",
    height: "44px",
    borderRadius: "6px",
    color: "#000000DF",
    backgroundColor: "#fff",
    "&:hover": {
      backgroundColor: "#007aff14",
      color: "#222",
    },
  }),
};

export { RATE_LIST, defaultSettingObject };

export const PAGE_SIZE = 10;
